import React from 'react';

interface TotalDataDisplayProps {
  currentPage: number;
  totalResults: number;
  label: string;
}

const TotalDataDisplay: React.FC<TotalDataDisplayProps> = ({
  currentPage,
  totalResults,
  label
}) => {
  const totalText = `${currentPage} of ${totalResults} ${label}`;

  return (
    <div className="font-normal text-sm text-neutral-600 flex justify-between items-end">
      {totalText}
    </div>
  );
};

export default TotalDataDisplay;
